import React from 'react';
import SelectionListItem, {
	SelectionListItemScheme,
} from './SelectionListItem';
import styles from './SelectionList.module.scss';

interface Props<T extends SelectionListItemScheme> {
	data: T[];
	onItemClick: (item: T) => void;
	buttonLabel: string;
}

const SelectionList = <T extends SelectionListItemScheme>({
	data,
	onItemClick,
	buttonLabel,
}: Props<T>) => {
	return (
		<div className={styles.wrapper}>
			{data.map(item => (
				<React.Fragment key={item.id}>
					<SelectionListItem<T>
						item={item}
						onClick={onItemClick}
						buttonLabel={buttonLabel}
					/>
				</React.Fragment>
			))}
		</div>
	);
};

export default SelectionList;
